(function () {
  function setSliderDraggable(wrapper, enabled) {
    var sliderEl = wrapper.closest('[data-flickity-slider]');
    if (!sliderEl || !window.Flickity) return;
    var flkty = window.Flickity.data(sliderEl);
    if (!flkty) return;
    flkty.options.draggable = enabled;
    if (enabled) {
      flkty.bindDrag && flkty.bindDrag();
    } else {
      flkty.unbindDrag && flkty.unbindDrag();
    }
  }

  function initZoomable(wrapper) {
    if (wrapper.dataset.zoomInit) return;
    wrapper.dataset.zoomInit = '1';

    var img = wrapper.querySelector('img');
    if (!img) return;

    var scale = 1;
    var posX = 0;
    var posY = 0;
    var startDist = 0;
    var startScale = 1;
    var pointers = {};
    var isPanning = false;
    var panStartX = 0;
    var panStartY = 0;
    var lastTapTime = 0;

    wrapper.style.overflow = 'hidden';

    function apply(animate) {
      img.style.transition = animate ? 'transform 0.2s ease-out' : 'none';
      img.style.transformOrigin = '0 0';
      img.style.willChange = 'transform';
      img.style.transform = 'translate(' + posX + 'px,' + posY + 'px) scale(' + scale + ')';
    }

    function clamp(animate) {
      var rect = wrapper.getBoundingClientRect();
      var minX = Math.min(0, rect.width - rect.width * scale);
      var minY = Math.min(0, rect.height - rect.height * scale);
      posX = Math.min(0, Math.max(minX, posX));
      posY = Math.min(0, Math.max(minY, posY));
      apply(animate);
    }

    function reset(animate) {
      scale = 1;
      posX = 0;
      posY = 0;
      wrapper.style.touchAction = '';
      apply(animate);
      setSliderDraggable(wrapper, true);
    }

    function pointerDistance() {
      var ids = Object.keys(pointers);
      if (ids.length < 2) return 0;
      var p1 = pointers[ids[0]];
      var p2 = pointers[ids[1]];
      return Math.hypot(p1.x - p2.x, p1.y - p2.y);
    }

    function pointerMidpoint() {
      var ids = Object.keys(pointers);
      var p1 = pointers[ids[0]];
      var p2 = pointers[ids[1]];
      return { x: (p1.x + p2.x) / 2, y: (p1.y + p2.y) / 2 };
    }

    function toggleZoom(clientX, clientY) {
      var rect = wrapper.getBoundingClientRect();
      if (scale > 1) {
        reset(true);
        return;
      }
      var localX = clientX - rect.left;
      var localY = clientY - rect.top;
      scale = 2.5;
      posX = localX - localX * scale;
      posY = localY - localY * scale;
      wrapper.style.touchAction = 'none';
      setSliderDraggable(wrapper, false);
      clamp(true);
    }

    wrapper.addEventListener('pointerdown', function (e) {
      pointers[e.pointerId] = { x: e.clientX, y: e.clientY };
      var count = Object.keys(pointers).length;

      if (count === 2) {
        startDist = pointerDistance();
        startScale = scale;
        wrapper.style.touchAction = 'none';
        setSliderDraggable(wrapper, false);
      } else if (count === 1 && scale > 1) {
        isPanning = true;
        panStartX = e.clientX - posX;
        panStartY = e.clientY - posY;
        wrapper.style.touchAction = 'none';
      }
    });

    wrapper.addEventListener('pointermove', function (e) {
      if (!pointers[e.pointerId]) return;
      pointers[e.pointerId] = { x: e.clientX, y: e.clientY };
      var count = Object.keys(pointers).length;

      if (count === 2) {
        e.preventDefault();
        var dist = pointerDistance();
        if (startDist > 0) {
          var newScale = Math.min(4, Math.max(1, startScale * (dist / startDist)));
          var mid = pointerMidpoint();
          var rect = wrapper.getBoundingClientRect();
          var localX = mid.x - rect.left;
          var localY = mid.y - rect.top;
          posX = localX - ((localX - posX) / scale) * newScale;
          posY = localY - ((localY - posY) / scale) * newScale;
          scale = newScale;
          clamp(false);
        }
      } else if (count === 1 && isPanning && scale > 1) {
        e.preventDefault();
        posX = e.clientX - panStartX;
        posY = e.clientY - panStartY;
        clamp(false);
      }
    });

    function endPointer(e) {
      delete pointers[e.pointerId];
      var count = Object.keys(pointers).length;
      if (count < 2) startDist = 0;
      if (count === 0) {
        isPanning = false;
        if (scale <= 1) {
          reset(true);
        } else {
          setSliderDraggable(wrapper, false);
        }
      }
    }

    wrapper.addEventListener('pointerup', endPointer);
    wrapper.addEventListener('pointercancel', endPointer);
    wrapper.addEventListener('pointerleave', endPointer);

    wrapper.addEventListener('dblclick', function (e) {
      e.preventDefault();
      toggleZoom(e.clientX, e.clientY);
    });

    wrapper.addEventListener(
      'touchend',
      function (e) {
        var now = Date.now();
        if (now - lastTapTime < 300 && e.changedTouches && e.changedTouches.length) {
          e.preventDefault();
          toggleZoom(e.changedTouches[0].clientX, e.changedTouches[0].clientY);
        }
        lastTapTime = now;
      },
      { passive: false }
    );
  }

  function initAll() {
    document.querySelectorAll('.product-gallery-image-wrapper').forEach(initZoomable);
  }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);
  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    initAll();
  }
})();
